"use client";

import { useEffect } from "react";
import PremiumContent from "rivals/components/shared/Icons/PremiumContent";
import Link from "rivals/components/shared/Link";
import { PATHS } from "rivals/shared/constants";
import { setData } from "rivals/shared/utils/qa";
import styles from "./Headline.module.scss";
import ShareModule from "./ShareModule";
import { Props } from "./types";

const DATA_PHILTER = "article";

function Headline({
  canEdit,
  contentId,
  estimatedReadTime,
  headline,
  publishedAtDate,
  printable = false,
  isPremium,
  premiumIconColor
}: Props): React.JSX.Element {
  useEffect(() => {
    if (printable) {
      window?.print();
    }
  }, [printable]);
  const editPath = PATHS.EDIT_ARTICLE.replace("[content_id]", `${contentId}`);

  return (
    <div className={styles.mainContainer}>
      <div className={styles.metaContainer}>
        <div className={styles.metaContent}>
          {isPremium && (
            <div
              className={styles.premiumBadge}
              style={{ backgroundColor: premiumIconColor }}
            >
              <PremiumContent
                {...setData(DATA_PHILTER, "premium-icon")}
                fillBg={premiumIconColor}
                style={{ marginRight: 12 }}
              />
              <div className={styles.premiumBadgeText}>PREMIUM CONTENT</div>
            </div>
          )}
          <div {...setData(DATA_PHILTER, "published-date")}>
            Published {publishedAtDate}
            {estimatedReadTime && ` - ${estimatedReadTime} read`}
          </div>
        </div>
        {!printable && (
          <div className={styles.shareEditRow}>
            {canEdit && (
              <Link
                data={`${DATA_PHILTER}-edit-button`}
                href={`${PATHS.HOME}${editPath}`}
              >
                Edit
              </Link>
            )}
            {!printable && (
              <div className={styles.shareModuleContainer}>
                <ShareModule data={`${DATA_PHILTER}-share-button`} />
              </div>
            )}
          </div>
        )}
      </div>
      <div className={styles.title}>{headline}</div>
    </div>
  );
}

export default Headline;
